<template>
  <video
    ref="video"
    width="100%"
    height="100%"
    :src="src"
    :controls="controls"
    :muted="muted"
    crossorigin="anonymous"
    preload="auto"
    @seeked="_seeked"
    @pause="_pause"
    @play="_play"
    @ended="_ended"
    @error="_throwError"
    @progress="_progress"
    @timeupdate="_timeupdate"
    @loadeddata="_loadeddata"
    @loadedmetadata="_loadedmetadata"
    disablePictureInPicture
    controlsList="nofullscreen nodownload noremoteplayback"
  >
  </video>
</template>

<script>
export default {
  name: 'BaseVideo',
  props: {
    src: {
      type: String
    },
    controls: {
      default: false
    },
    currentTime: {
      type: Number
    },
    play: {
      type: Boolean
    },
    muted: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    currentTime (val) {
      if (typeof val === 'number') {
        console.log({ val })
        this.$refs.video.currentTime = val
      }
    },
    play (bool) {
      console.log('---------play video--------')
      let video = this.$refs.video
      if (bool) {
        video.play()
      } else {
        video.pause()
      }
    }
  },
  mounted () {
    if (this.muted) {
      this.$refs.video.setAttribute('muted', 'muted')
    }
    this.$emit('mounted')
  },
  methods: {
    _seeked (e) {
      this.$emit('seeked', e)
    },
    _pause (e) {
      this.$emit('pause', e)
    },
    _play (e) {
      this.$emit('play', e)
    },
    _ended (e) {
      this.$emit('ended', e)
    },
    _throwError (e) {
      this.$emit('error', e)
    },
    _progress (e) {
      this.$emit('progress', e)
    },
    _timeupdate (e) {
      this.$emit('timeupdate', e)
    },
    _loadeddata (e) {
      this.$emit('loadeddata', e)
    },
    _loadedmetadata (e) {
      this.$emit('loadedmetadata', e)
    }
  }
}
</script>

<style>
  video::-webkit-media-controls-fullscreen-button{ display: none; }
</style>

